export const taxes = {
  AB: 'Imposta governativa',
  AC: 'Imposta sul valore aggiunto',
  AE: 'Tassa di servizio per i passeggeri (internazionale)',
  AF: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  AG: 'Imposta sul biglietto',
  AH: 'Tassa aeroportuale',
  AI: 'Tassa per il controllo di sicurezza dei bagagli',
  AJ: "Tassa di uscita dall'aeroporto (internazionale)",
  AK: "Tassa di partenza dall'aeroporto (internazionale)",
  AL: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  AM: 'Imposta',
  AN: 'Tassa sulle strutture aeroportuali (nazionali/internazionali)',
  AO: "Tassa d'imbarco (internazionale)",
  AP: 'Costo della sicurezza (nazionale/internazionale)',
  AR: 'Tassa sul biglietto',
  AT: 'Tassa di sicurezza per i passeggeri (nazionale/internazionale)',
  AU: 'Tariffa per il movimento dei passeggeri',
  AV: 'Imposta sullo sviluppo del turismo (internazionale)',
  AW: 'Tariffa per le strutture e la sicurezza dei passeggeri',
  AX: 'Commissione di servizio per i passeggeri (nazionale)',
  AY: "Tassa per il servizio di sicurezza dell'aviazione civile per i passeggeri (nazionale/internazionale)",
  AZ: 'Tassa di partenza (internazionale)',
  BA: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  BB: 'Imposta sul valore aggiunto',
  BC: 'Tassa di sicurezza aeroportuale (nazionale/internazionale)',
  BD: "Tassa d'imbarco (nazionale/internazionale)",
  BE: 'Servizio passeggeri e tassa di sicurezza',
  BF: 'Imposta di bollo / sicurezza / vendite / turismo (nazionale/internazionale)',
  BG: 'Tariffa passeggeri (nazionale/internazionale)',
  BH: 'Imposta governativa',
  BK: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  BL: 'Tassa per la sicurezza aerea',
  BM: 'Tassa governativa sui passeggeri',
  BN: 'Tassa sui servizi ai passeggeri (internazionale)',
  BO: 'Imposta sulle vendite (nazionale/internazionale)',
  BP: "PSC, tassa di partenza e contributo all'eliminazione internazionale della povert\u00e0",
  BQ: 'Tassa aeroportuale',
  BR: "Tassa d'imbarco (nazionale/internazionale)",
  BS: 'Tassa sul biglietto (internazionale)',
  BU: 'Tassa di sviluppo aeroportuale',
  BW: 'Tassa di partenza (nazionale/internazionale)',
  BX: 'Tassa di sicurezza (nazionale/internazionale)',
  BY: 'Imposta sulle vendite (internazionale)',
  BZ: 'Tassa sul biglietto',
  CA: 'Tassa di sicurezza per i viaggiatori aerei (nazionali/internazionali)*',
  CB: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  CC: 'Tassa di servizio per i passeggeri delle isole Cocos',
  CD: "Tassa d'imbarco / vendita / turismo (nazionale/internazionale)",
  CE: "Contributo per i controlli di sicurezza dell'aviazione (nazionale)",
  CF: 'Imposta di sicurezza',
  CG: 'Imposta sulle vendite/di sicurezza (nazionale/internazionale)',
  CH: "Tassa sulla sicurezza e sul rumore dei passeggeri dell'aeroporto (nazionale/internazionale)",
  CI: 'Tassa di sicurezza/turismo (nazionale/internazionale)',
  CJ: 'Costo del servizio di sicurezza (nazionale/internazionale)',
  CL: 'Tassa sulle strutture aeroportuali (nazionale)',
  CM: 'Imposta sul valore (nazionale/internazionale)',
  CN: 'Tassa aeroportuale (nazionale/internazionale)',
  CO: 'Tassa aeroportuale (nazionale/internazionale)',
  CQ: 'Fondo di riabilitazione e assistenza ai disabili',
  CR: 'Tassa sui trasporti',
  CT: 'Tassa di sicurezza (nazionale/internazionale)',
  CV: "Tassa d'imbarco all'aeroporto (nazionale/internazionale)",
  CW: 'Imposta sul valore aggiunto (nazionale)',
  CX: "Tassa di servizio per i passeggeri dell'Isola di Natale (nazionali/internazionali)",
  CY: 'Tassa di servizio aeroportuale (internazionale)',
  CZ: "Tassa d'imbarco (nazionale/internazionale)",
  DA: 'Commissione di servizio per i passeggeri (nazionale)',
  DB: 'Onere per la sicurezza aeroportuale',
  DC: 'Costo della sicurezza (nazionale/internazionale)',
  DD: 'Tassa di atterraggio (internazionale)',
  DE: 'Tassa di sicurezza aeroportuale (nazionale/internazionale)',
  DF: 'Oneri di sicurezza (internazionali)',
  DG: 'Tassa di uscita per i residenti (Timbre)',
  DH: 'Tariffa per le strutture per i passeggeri',
  DI: 'Tassa di facilitazione aeroportuale (internazionale)',
  DJ: 'Tassa di partenza',
  DL: 'Imposta sul valore aggiunto (passeggeri)',
  DM: 'Tassa sui trasporti (internazionale)',
  DN: 'Imposta sul valore aggiunto (bagaglio in eccesso)',
  DO: 'Tassa sui trasporti (nazionale/internazionale)',
  DP: 'Imposta sui beni e servizi (GST), (nazionale/internazionale)',
  DQ: 'Costo della sicurezza (nazionale/internazionale)',
  DR: 'Tassa sulle strutture aeroportuali (nazionali/internazionali)',
  DS: 'Tassa di sicurezza (internazionale)',
  DT: 'Tassa di trasferimento passeggeri (nazionale/internazionale)',
  DW: "Tassa d'imbarco (nazionale/internazionale)",
  DX: 'Onere per lo sviluppo aeronautico (Intl)',
  DY: 'Tassa di soggiorno',
  DZ: 'Trasporti / Fiscale / Tassa aeroportuale',
  EA: 'Tassa di partenza per i passeggeri',
  EB: 'Tassa sui passeggeri e sulla sicurezza (nazionale/internazionale)',
  EC: 'Tassa governativa sui trasporti (nazionale/internazionale)',
  ED: 'Tassa di soggiorno (internazionale)',
  EE: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  EF: 'Tassa di sicurezza (nazionale/internazionale)',
  EG: 'Tassa sui trasporti',
  EI: 'Imposta di conguaglio IVA (Dom)',
  EJ: 'Supplemento PTA (Internazionale)',
  EK: 'Tassa per il servizio passeggeri e la sicurezza (nazionale/internazionale)',
  EL: "Tassa per il miglioramento dell'aeroporto",
  EM: 'Tassa di servizio aeroportuale',
  EN: 'Tariffa per le strutture per i passeggeri',
  EO: 'Tassa di espansione aeroportuale',
  EP: 'Tassa sullo sviluppo (internazionale)',
  EQ: 'Costo del servizio (nazionale/internazionale)',
  ER: 'Imposta sulle vendite (nazionale/internazionale)',
  ES: 'Imposta sul valore aggiunto (IVA)',
  ET: 'Imposta di bollo, viaggi aerei internazionali/internazionali',
  EU: "INAC - Tassa per il miglioramento dei servizi dell'aviazione civile (nazionale/internazionale)",
  EV: 'Onere per la sicurezza dei passeggeri (nazionale/internazionale)',
  EW: 'Tassa per le strutture per i passeggeri',
  EX: 'Costo della borsa di sicurezza (nazionale/internazionale)',
  EY: "Tassa di partenza dall'aeroporto",
  EZ: 'Onere per la sicurezza aeroportuale',
  FA: 'Oneri per lo sviluppo aeroportuale',
  FB: 'Tassa di agevolazione per il potenziamento degli aeroporti (nazionali/internazionali)',
  FC: 'Tassa di terminale (internazionale)',
  FD: 'Tassa di soggiorno (internazionale)',
  FE: 'Costo della sicurezza (nazionale/internazionale)',
  FF: 'Costo del controllo bagagli (internazionale)',
  FG: 'Tassa di controllo dei passeggeri (nazionali/internazionali)',
  FH: "Tassa di partenza dall'aeroporto (SXM) (nazionale/internazionale)",
  FI: 'Tassa sui passeggeri (internazionale)',
  FJ: 'Imposta sul valore aggiunto',
  FL: 'Commissione di servizio per i passeggeri (nazionale)',
  FN: 'Imposta sul valore aggiunto su IT/EX/VT/HB (Dom)',
  FO: 'Tassa di partenza',
  FP: 'Tassa per il controllo della sicurezza',
  FQ: 'Imposta municipale di Abidjan (nazionale/internazionale)',
  FR: 'Tassa aeroportuale (nazionale/internazionale)',
  FS: "Canone per l'utilizzo dell'area comune (Intl)",
  FU: 'Imposta di conservazione',
  FV: 'Tassa per il servizio passeggeri',
  FW: 'Tassa di sicurezza (internazionale)',
  FX: 'Imposta di sicurezza',
  FZ: "Tassa di partenza dall'aeroporto",
  GA: 'Tassa aeroportuale (nazionale/internazionale)',
  GB: 'Dazi sui passeggeri aerei (APD) (nazionali/internazionali)',
  GC: 'Spese per le strutture dei terminali (nazionali/internazionali)',
  GD: 'Tassa sui biglietti governativi',
  GE: 'Tassa sui passeggeri (nazionali/internazionali)',
  GF: "Tassa d'imbarco",
  GG: 'Tassa di sicurezza aeroportuale (nazionale/internazionale)',
  GH: 'Tassa di servizio per i passeggeri (internazionale)',
  GI: 'Commissione di servizio per i passeggeri',
  GJ: 'Tassa sulle strutture aeroportuali (nazionali/internazionali)',
  GK: 'Tassa di sicurezza (nazionale/internazionale)',
  GM: 'Imposta sulle vendite del governo',
  GN: 'Costo del servizio (nazionale/internazionale)',
  GO: 'Canone di manutenzione della struttura di sicurezza',
  GP: "Tassa d'imbarco/partenza",
  GQ: 'Tassa di partenza (nazionale/internazionale)',
  GR: 'Tassa di sviluppo aeroportuale (nazionale/internazionale)',
  GU: 'Onere per i servizi di ispezione doganale, agricola e di quarantena',
  GV: 'Imposta di bollo',
  GW: 'Imbarco / Sicurezza / Imposta di bollo (nazionale/internazionale)',
  GX: 'Tassa di terminale (nazionale/internazionale)',
  GY: 'Imposta sulle vendite del governo',
  GZ: 'Tassa di servizio aeroportuale (internazionale)',
  HA: 'Carica di sicurezza di Tirana (internazionale)',
  HB: 'Imposta comunale (nazionale/internazionale)',
  HC: 'Tassa di sviluppo (nazionale/internazionale)',
  HD: 'Onere per la sicurezza (nazionale/internazionale)',
  HE: 'Tassa di sviluppo aeroportuale (nazionale/internazionale)',
  HF: 'Imposta sul valore aggiunto',
  HG: 'Tassa di valorizzazione del turismo (internazionale)',
  HH: 'Tassa sui passeggeri (internazionale)',
  HI: "Tassa per il trattamento dell'immigrazione",
  HJ: 'Tariffa di struttura per i passeggeri (nazionale)',
  HK: 'Tassa di partenza per i passeggeri aerei',
  HL: 'Tassa di sviluppo aeroportuale (internazionale)',
  HN: 'Tassa sui trasporti (nazionale/internazionale)',
  HO: 'Costo del trasporto aereo',
  HP: "Canone per lo sviluppo dell'infrastruttura (nazionale/internazionale)",
  HQ: "Tassa d'imbarco (internazionale)",
  HR: 'Tassa aeroportuale (nazionale/internazionale)',
  HS: 'Tassa aeroportuale (internazionale)',
  HT: 'Tassa sui trasporti (nazionale/internazionale)',
  HU: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  HV: 'Tassa sui passeggeri (internazionale)',
  HW: "Tassa di partenza dall'aeroporto (internazionale)",
  HX: 'Tassa di sicurezza (nazionale/internazionale)',
  HY: 'Tassa per la sicurezza aerea (nazionale/internazionale)',
  HZ: 'Tassa di solidariet\u00e0',
  IA: 'Tassa di sicurezza per i passeggeri (internazionale)',
  IB: 'Tassa aeroportuale (nazionale/internazionale)',
  IC: 'Tassa di sviluppo (internazionale)',
  ID: 'Imposta sul valore aggiunto (nazionale)',
  IF: "Tassa di partenza dall'aeroporto (internazionale)",
  IG: 'Tassa di immigrazione',
  IH: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  II: 'Onere di facilitazione',
  IJ: 'Onere per la sicurezza (internazionale)',
  IK: 'Tassa di sicurezza (internazionale)',
  IL: 'Tassa aeroportuale per i passeggeri in partenza (Intl.)',
  IM: 'Tassa di contribuzione al turismo (internazionale)',
  IN: 'Tassa di sviluppo utente (nazionale/internazionale)',
  IP: 'Tassa di sviluppo (nazionale/internazionale)',
  IR: 'Tassa aeroportuale (internazionale)',
  IS: 'Costo del servizio aeroportuale (nazionale/internazionale)',
  IT: "Tassa d'imbarco (nazionale/internazionale)",
  IU: 'Tassa di sicurezza per i passeggeri (internazionale)',
  IV: 'Tassa per il miglioramento delle infrastrutture aeroportuali (nazionale)',
  IW: "Tassa per il miglioramento dell'aeroporto (nazionale/internazionale)",
  IX: 'Tassa di attraversamento delle frontiere (internazionale)',
  IY: 'Imposta sul valore aggiunto (nazionale) / Tassa di partenza (internazionale)',
  IZ: 'Tassa di solidariet\u00e0 per i passeggeri aerei (nazionali/internazionali)',
  JA: "Tassa di sicurezza per i passeggeri dell'aeroporto (nazionale/internazionale)",
  JB: "IVA SULLA TASSA DI PARTENZA DALL'AEROPORTO",
  JC: 'Tassa di servizio per i passeggeri (internazionale)',
  JD: 'Costo di partenza (nazionale/internazionale)',
  JE: 'Tassa di solidariet\u00e0 per i passeggeri (internazionale)',
  JF: 'Tassa di atterraggio (internazionale)',
  JG: 'Tassa di servizio per i passeggeri (internazionale)',
  JH: 'Tassa di sicurezza (internazionale)',
  JI: 'Tassa sui servizi dei passeggeri aerei (APSC) (nazionali/internazionali)',
  JJ: 'Tassa di sicurezza',
  JK: 'Tassa di partenza',
  JL: 'Tassa sulla sicurezza dei voli',
  JM: 'Imposta di bollo (nazionale/internazionale)',
  JN: 'Tassa di servizio sui viaggi in classe premium',
  JO: 'Imposta sulle vendite dei biglietti (internazionale)',
  JP: 'Imposta sui consumi',
  JQ: 'Onere della sicurezza - Internazionale',
  JR: 'Tassa di solidariet\u00e0 (nazionale/internazionale)',
  JS: 'Imposta sul turismo',
  JT: "Promozione dell'imposta sul turismo",
  JU: 'Tassa di solidariet\u00e0 dei passeggeri aerei (internazionale)',
  JV: 'Tassa di solidariet\u00e0 (internazionale)',
  JW: 'Tassa sulla sicurezza (internazionale)',
  JX: 'Tassa di servizio per i passeggeri (internazionale)',
  JY: 'Imposta sul valore aggiunto (IVA)',
  JZ: 'Imposta di bollo (nazionale/internazionale)',
  KA: 'Tassa di sicurezza del volo (internazionale)',
  KB: 'Imposta sullo sviluppo del turismo (internazionale)',
  KC: 'Diritti aeroportuali e di sicurezza per i passeggeri',
  KD: "Canone per l'infrastruttura",
  KE: 'Tassa sui servizi aeroportuali per i passeggeri (nazionali)',
  KF: 'Imposta sul valore aggiunto (internazionale)',
  KJ: "Tassa sull'aviazione civile",
  KK: 'Tassa di servizio per i passeggeri (internazionale)',
  KL: 'Imposta sul valore aggiunto',
  KM: 'Aeroporto / Sicurezza / Imposta di bollo (nazionale/internazionale)',
  KN: 'Imposta sulle vendite (nazionale/internazionale)',
  KO: 'Imposta sullo sviluppo territoriale',
  KP: 'Tassa di servizio per i passeggeri (internazionale)',
  KQ: "Onere per l'aviazione civile",
  KS: 'Tassa di servizio aeroportuale (internazionale)',
  KT: 'Tassa di servizio per i passeggeri (internazionale)',
  KU: 'Imposta comunale',
  KV: 'Tassa sui passeggeri aerei (nazionali/internazionali)',
  KW: "Tassa di partenza dall'aeroporto",
  KX: 'Commissione di servizio per i passeggeri - Nazionale',
  KY: 'Tassa di partenza (internazionale)',
  KZ: 'Imposta sulle vendite (nazionale/internazionale)',
  LA: 'Tassa sui servizi aeroportuali per i passeggeri (nazionali/internazionali)',
  LB: "Tassa d'imbarco all'aeroporto di Beirut (internazionale)",
  LC: 'Tassa di viaggio',
  LD: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  LE: 'Tariffa per le strutture per i passeggeri',
  LF: 'Tassa sui passeggeri (nazionale/internazionale)',
  LG: 'Costo della sicurezza (nazionale/internazionale)',
  LH: "Tassa di partenza dall'aeroporto - Internazionale",
  LJ: 'Regolamento CAA Tassa',
  LK: "Tassa d'imbarco (CMB)",
  LL: 'Imposta di sicurezza',
  LM: "Imposta sull'amministrazione locale",
  LN: 'Imposta sul valore aggiunto',
  LO: 'Tariffa per il controllo del bagaglio da stiva',
  LQ: 'Tassa sui viaggi aerei (nazionali/internazionali)',
  LR: 'Tassa sul biglietto',
  LT: 'Tassa aeroportuale (nazionale/internazionale)',
  LU: 'Commissione di servizio per i passeggeri',
  LV: 'Tassa di partenza e di sicurezza per i passeggeri (nazionale/internazionale)',
  LY: 'Imposta sul biglietto',
  MA: 'Sicurezza aeroportuale / Attrezzature / Servizio passeggeri / Imposta di bollo sui biglietti',
  MD: 'Tassa di sviluppo aeroportuale',
  ME: 'Tassa di partenza (internazionale)',
  MG: 'Tassa sui passeggeri (nazionale/internazionale)',
  MJ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  MK: 'Tassa di servizio aeroportuale (nazionale/internazionale)',
  ML: 'Tassa sul biglietto (nazionale/internazionale)',
  MN: 'Commissione di servizio per i passeggeri',
  MO: 'Tassa di sicurezza aeroportuale',
  MQ: "Tassa d'imbarco",
  MR: 'Imbarco / Bollo fiscale / Tassa di sicurezza',
  MT: 'Tassa aeroportuale',
  MU: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  MW: 'Imposta sul reddito (Dom.)',
  MX: 'Tassa sul trasporto / Eccesso di bagaglio',
  MY: 'Tassa per il servizio passeggeri e la sicurezza (nazionale/internazionale)',
  MZ: 'Imposta sul valore aggiunto (nazionale)',
  NA: 'Costo del servizio passeggeri (nazionale/internazionale)',
  NC: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  NE: 'Bollo fiscale / Sicurezza / Tassa sui trasporti',
  NF: 'Tariffa di servizio per i passeggeri nazionali (australiani)',
  NG: 'Imposta sulle vendite (nazionale/internazionale)',
  NI: 'Imposta sulle vendite (Hacienda) (nazionale/internazionale)',
  NP: 'Tassa di servizio per i passeggeri (internazionale)',
  NQ: 'Tassa di servizio per il turismo (internazionale)',
  NV: 'Imposta sul valore aggiunto (IVA) Dom.',
  NZ: 'Imposta sui beni e servizi (GST) - Passeggeri',
  OA: 'Tariffe di prenotazione delle compagnie aeree',
  OB: 'Tariffe di biglietteria aerea',
  OC: 'Tariffe di servizio delle compagnie aeree',
  OI: 'Tassa per il servizio passeggeri e la sicurezza (internazionale)',
  OM: 'Tassa aeroportuale',
  OO: 'Costo del servizio di sicurezza per i passeggeri',
  OP: "Tassa sull'aviazione",
  OW: 'Accise',
  OY: 'Tassa sul trasporto aereo',
  PA: 'Tassa sul turismo (nazionale/internazionale)',
  PE: 'Imposta sulle vendite (nazionale/internazionale)',
  PF: 'Tassa di partenza (nazionale/internazionale)',
  PG: 'Tassa di partenza',
  PH: 'Viaggio / Imposta sul capo non residente',
  PK: 'Accise',
  PT: 'Tassa di sicurezza (nazionale/internazionale)',
  PV: 'Imposta sul valore aggiunto (IVA) Nazionale',
  PY: 'Tassa sui trasporti (internazionale)',
  QA: 'Tassa aeroportuale (internazionale)',
  QG: 'Imposta sul valore aggiunto (enti commerciali)',
  QH: "Tassa d'imbarco",
  QK: 'Imposta sul rumore (nazionale/internazionale)',
  QL: 'Costo del servizio aeroportuale (nazionale/internazionale)',
  QM: 'Costo del servizio (domestico)',
  QN: 'Imposta lorda sui ricavi (nazionale)',
  QO: 'Servizi doganali e di immigrazione Tassa (internazionale)',
  QR: 'Commissione di servizio per i passeggeri -Dom',
  QS: 'Tariffa per le strutture per i passeggeri',
  QT: 'Costo del servizio aeroportuale (nazionale/internazionale)',
  QU: 'Tassa sui passeggeri (nazionale)',
  QV: 'Tassa di sicurezza (nazionale/internazionale)',
  QW: 'Commissione di servizio per i passeggeri -Dom',
  QX: 'Commissione di servizio per i passeggeri -Intl',
  QY: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  QZ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  RA: 'Tassa di servizio per i passeggeri -Intl.',
  RB: 'Tassa di servizio per i passeggeri (internazionale)',
  RC: 'Imposta sulle vendite armonizzata',
  RD: 'Commissione di servizio per i passeggeri -Dom.',
  RE: "Tassa d'imbarco (internazionale)",
  RG: 'Accisa federale (FED)',
  RH: 'Costo del servizio (domestico)',
  RI: "Tassa per l'uso del terminale (internazionale)",
  RJ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  RK: 'Tassa di sicurezza (nazionale/internazionale)',
  RL: "Tassa d'imbarco (internazionale)",
  RN: 'Tassa di servizio per i passeggeri (nazionali/internazionali)',
  RO: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  RQ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  RS: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  RT: 'Tassa di partenza (regionale)',
  RU: 'Imposta sulle vendite (internazionale) -Compagnie aeree russe',
  RV: 'Imposta sul valore aggiunto',
  RW: 'Tassa di servizio per i passeggeri (nazionali/internazionali)',
  RX: 'Imposta sul turismo',
  RZ: 'Imposta di bollo (nazionale/internazionale)',
  SB: 'Tassa di vendita dei biglietti governativi (nazionali/internazionali)',
  SC: 'Imposta sui beni e servizi (nazionale/internazionale)',
  SD: 'Imposta di bollo (nazionale/internazionale)',
  SG: 'Commissione di servizio per i passeggeri',
  SI: 'Commissione di servizio per i passeggeri',
  SK: "Tassa d'imbarco (nazionale/internazionale)",
  SL: "Tassa sui viaggi all'estero",
  SN: 'Imposta di bollo fiscale (nazionale/internazionale)',
  SP: "Tassa d'imbarco (nazionale/internazionale)",
  SQ: "Tassa per il miglioramento dell'aeroporto (AIF), (nazionale/internazionale)",
  SR: 'Tassa sulle strutture aeroportuali (internazionale)',
  ST: 'Assistenza pubblica / Imposta di bollo (nazionale/internazionale)',
  SU: 'Tassa di sicurezza (nazionale/internazionale)',
  SV: 'Imposta sul valore aggiunto (persone fisiche)',
  SW: 'Tariffa per le strutture di servizio ai passeggeri (internazionale)',
  SX: 'Tassa di servizio per i passeggeri (internazionale)',
  SY: 'Imposta di bollo (nazionale/internazionale)',
  TA: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  TASF: 'Tassa per i servizi di agenzia di viaggio',
  TB: 'Imposta sui beni e servizi (nazionale/internazionale)',
  TC: 'Tassa sui passeggeri / Tassa di sicurezza',
  TD: "Tassa d'imbarco (nazionale/internazionale)",
  TG: 'Tassa di viaggio',
  TI: 'Imposta di bollo (nazionale/internazionale)',
  TM: 'Tassa aeroportuale sui passeggeri internazionali',
  TN: 'Imposta di bollo fiscale (nazionale/internazionale)',
  TO: 'Contributo di sicurezza e tassa di sviluppo aeroportuale',
  TQ: 'Tassa di sicurezza (nazionale/internazionale)',
  TR: 'Tassa di servizio aeroportuale (internazionale)',
  TS: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  TT: 'Imposta sul valore aggiunto',
  TU: 'Tassa sui servizi aeroportuali per i passeggeri (internazionale)',
  TW: 'Tassa di servizio aeroportuale -Intl',
  TX: 'Documento sulla tassa per scopi multipli',
  TZ: 'Tassa aeroportuale (nazionale/internazionale)',
  UA: 'Costo della sicurezza (nazionale/internazionale)',
  UB: 'Tassa di servizio per i passeggeri (nazionali/internazionali)',
  UD: 'Carica di Stato - (Nazionale/Internazionale)',
  UE: 'Imposta sul valore aggiunto - Nazionale',
  UF: 'Commissione di servizio per i passeggeri -Intl',
  UG: 'Costo della sicurezza (nazionale/internazionale)',
  UH: 'Onere per la sicurezza (internazionale)',
  UI: 'IVA Imposta di conguaglio',
  UJ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  UK: 'Imposta sul turismo (Derecho No Inmigrante)',
  UL: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  UM: 'Servizio passeggeri e tassa di sicurezza',
  UN: 'Imposta sui beni e servizi (GST)',
  UO: 'Imposta sui beni e servizi (GST)',
  UP: 'Tariffa passeggeri (nazionale/internazionale)',
  UQ: 'Costo della pre-ispezione',
  UR: 'Tassa di partenza (internazionale)',
  US: 'Tassa sui trasporti (nazionale/internazionale)',
  UT: "Tassa sui viaggi aerei all'estero (FATT)",
  UU: 'Tassa aeroportuale (nazionale/internazionale) BSL',
  UV: "Tassa di partenza dall'aeroporto (nazionale)",
  UW: 'Imposta sul valore aggiunto (nazionale)',
  UX: "Tassa dell'Autorit\u00e0 aeroportuale",
  UY: 'Imposta sulle vendite dei biglietti',
  UZ: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  VB: 'Tassa per le infrastrutture aeroportuali',
  VC: 'Imposta governativa',
  VD: 'Tassa di servizio aeroportuale (nazionale/internazionale)',
  VE: 'Tassa sul contributo di soggiorno (nazionale/internazionale)',
  VF: 'Tassa sugli aiuti nazionali (nazionali/internazionali)',
  VG: 'Tassa di sviluppo aeroportuale - Internazionale',
  VH: 'Tassa sullo sviluppo (nazionale/internazionale)',
  VJ: 'Tariffa speciale per le strutture',
  VL: 'Tassa di partenza',
  VM: 'Tassa di servizio per i passeggeri (internazionale)',
  VN: 'Imposta sulle vendite',
  VO: 'Commissione di servizio per i passeggeri',
  VP: 'Tassa di soggiorno',
  VQ: 'Tassa di servizio aeroportuale (nazionale)',
  VR: 'Tassa di servizio per i passeggeri (internazionale)',
  VS: 'Tassa di sicurezza (nazionale/internazionale)',
  VT: 'Costo della sicurezza (nazionale/internazionale)',
  VU: 'Tassa di partenza e tassa di sicurezza (internazionale)',
  VV: 'Tariffa di isolamento acustico (nazionale/internazionale)',
  VW: 'Tariffa di facilitazione (internazionale)',
  VX: 'Tassa di sicurezza (nazionale/internazionale)',
  VY: 'Tassa sullo sviluppo (internazionale)',
  VZ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  WA: 'IVA - Imposta sul valore aggiunto',
  WB: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  WC: 'Tassa sui passeggeri aerei',
  WD: 'Tassa di viaggio (internazionale)',
  WG: 'Onere per la sicurezza (nazionale/internazionale)',
  WH: 'Tassa di utilizzo del terminal (internazionale)',
  WI: 'Commissione di servizio per i passeggeri',
  WJ: 'Onere per la sicurezza (internazionale)',
  WK: 'Tassa sui passeggeri (Intl)',
  WL: 'Tassa sui passeggeri (transito internazionale)',
  WM: "Tassa di partenza dall'aeroporto (internazionale)",
  WN: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  WO: 'Tassa di servizio per i passeggeri (nazionali/internazionali)',
  WP: 'Tassa per le strutture dei terminali passeggeri (nazionali/internazionali)',
  WQ: 'Tassa di sicurezza per i passeggeri (nazionale/internazionale)',
  WS: 'Imposta sul valore aggiunto',
  WT: 'Tassa di sicurezza (nazionale/internazionale)',
  WU: 'Tassa di partenza (internazionale)',
  WV: "Tassa di partenza dall'aeroporto (nazionale/internazionale)",
  WW: 'Tassa di servizio per i passeggeri (internazionale)',
  WX: 'Tassa sui passeggeri (nazionale)',
  WY: 'Tassa sui servizi ai passeggeri -Intl',
  WZ: 'Onere della sicurezza (internazionale)',
  XA: "Tassa d'uso APHIS -Passeggeri",
  XB: 'Imposta sul valore aggiunto (nazionale/internazionale)',
  XC: 'Tassa di partenza (internazionale)',
  XD: "Tassa di partenza dall'aeroporto -TUA (internazionale)",
  XE: 'Tassa aeroportuale (internazionale)',
  XF: 'Tariffa per le strutture per i passeggeri',
  XG: 'Imposta sui beni e servizi (GST)',
  XH: 'Imposta sul valore aggiunto',
  XJ: 'Imposta sul valore aggiunto',
  XK: 'Tassa di emissione del biglietto',
  XL: 'Imposta di bollo (nazionale/internazionale/bagaglio in eccesso)',
  XO: 'Tassa sui trasporti -IVA (Internazionale)',
  XP: 'Costo del servizio PTA',
  XQ: 'Imposta sulle vendite in Quebec',
  XR: 'Tassa aeroportuale (nazionale/internazionale)',
  XS: 'Imposta sul valore aggiunto',
  XV: "Tassa di partenza dall'aeroporto -TUA (Nazionale)",
  XW: 'Tassa aeroportuale (nazionale/internazionale)',
  XX: 'Imposta sul valore aggiunto',
  XY: "Tassa sull'immigrazione",
  YA: 'Costo del passeggero (nazionale/internazionale)',
  YB: 'Imposta sul valore aggiunto',
  YC: 'Tassa doganale',
  YE: 'Imposta sul turismo',
  YF: 'Imposta sul valore aggiunto',
  YG: 'Tassa di sicurezza (nazionale/internazionale)',
  YH: "Tassa d'imbarco (TEBA)",
  YK: "Tassa sui passeggeri dell'aeroporto (nazionali/internazionali)",
  YL: 'Tassa di emissione del biglietto (nazionale/internazionale)',
  YN: 'Tassa sul lusso (nazionale/internazionale)',
  YO: 'Dazio sui passeggeri aerei (APD), (nazionale/internazionale)',
  YP: 'Tassa di servizio per i passeggeri (nazionali/internazionali)',
  YQ: 'Supplemento carburante e assicurazione delle compagnie aeree',
  YR: 'Supplemento carburante e assicurazione della compagnia aerea/tassa di transazione di pagamento',
  YS: 'Imposta sulle vendite (nazionale/internazionale) = I.V.A.',
  ZA: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  ZB: 'Tassa di servizio per i passeggeri (internazionale)',
  ZC: 'Tassa di servizio per i passeggeri (internazionale)',
  ZD: 'Tassa di servizio per i passeggeri (internazionale)',
  ZE: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  ZG: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  ZH: 'Tassa di servizio per i passeggeri (internazionale)',
  ZI: 'Tassa di servizio per i passeggeri (internazionale)',
  ZJ: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  ZL: 'Imposta di bollo fiscale (nazionale/internazionale)',
  ZM: 'Imposta sulle vendite (nazionale)',
  ZN: 'Tariffa passeggeri (nazionale/internazionale)',
  ZO: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  ZP: 'Tassa sul segmento di volo (nazionale)',
  ZQ: 'Tassa sulle strutture aeroportuali (internazionale)',
  ZS: 'Imposta sul valore aggiunto',
  ZT: 'Onere per lo sviluppo aeronautico',
  ZU: 'Tassa sui passeggeri (Keflavik)',
  ZV: 'Imposta sul valore aggiunto',
  ZX: 'Tassa sui passeggeri (trasferimento)',
  ZY: 'Commissione di servizio per i passeggeri (nazionali/internazionali)',
  ZZ: 'Piano di fatturazione e liquidazione Pseudo codice fiscale',
};
